import { render, staticRenderFns } from "./sqChart.vue?vue&type=template&id=24efa8e8&scoped=true"
import script from "./sqChart.vue?vue&type=script&lang=js"
export * from "./sqChart.vue?vue&type=script&lang=js"
import style0 from "./sqChart.vue?vue&type=style&index=0&id=24efa8e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efa8e8",
  null
  
)

export default component.exports